import CommonConstant from "../constants/common.constant";

const ConsoleLog = (message: any, data?: string) => {
  if (`${process.env.ENVIRONMENT}` == CommonConstant.localEnvironemt) {
    if (data) console.log(message, data);
    else console.log(message, data);
  }
};

const ConsoleLogError = (message: any, data?: string) => {
  if (`${process.env.ENVIRONMENT}` == CommonConstant.localEnvironemt) {
    if (data) console.error(message, data);
    else console.error(message, data);
  }
};

const getDeviceName = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "TAB";
  } else if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "MOBILE";
  } else {
    return "PC";
  }
};

const formatString = (format: string, ...args: any[]): string => {
  return format.replace(/{(\d+)}/g, (match, index) => {
    const argIndex = parseInt(index, 10);
    return args[argIndex] !== undefined ? args[argIndex].toString() : match;
  });
};

const isFormFieldInvalid = (name: any, form: any) =>
  !!(form.touched[name] && form.errors[name]);

const getFormErrorMessage = (name: any, form: any) => {
  return isFormFieldInvalid(name, form)
    ? '<small className="p-error">' + form.errors[name] + "</small>"
    : '<small className="p-error">&nbsp;</small>';
};

const getNext7Days = () => {
  const today = new Date();
  let next7Days = "";

  const nextDay = new Date(today);
  nextDay.setDate(today.getDate() + 7);
  next7Days = nextDay.toDateString();

  return next7Days;
};

const getNext7DaysByDate = (date: Date) => {
  let next7Days = "";

  const nextDay = new Date(date);
  nextDay.setDate(date.getDate() + 7);
  next7Days = nextDay.toDateString();

  return next7Days;
};

const formatAmountInINR = (amount: number) => {
  const formattedAmount = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount);

  return formattedAmount;
};

const formatPaymentMode = (modeName: string) => {
  if (!modeName) return "";
  return modeName.trim().toLowerCase() === "cash" ? "Cash At Store" : modeName;
};

const buildDate = (year: number, monthIndex: number, day: number) => {
  const date = new Date(year, monthIndex, day);

  // Guard against rollovers like 32-Jan or month 13 becoming the next year.
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== monthIndex ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

const parseDelimitedDate = (raw: string) => {
  const match = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})(?:\s+.*)?$/);
  if (!match) return null;

  const [, first, second, year] = match;
  const firstNum = Number(first);
  const secondNum = Number(second);
  const yearNum = Number(year);

  // Prefer the unambiguous interpretation first.
  if (firstNum > 12 && secondNum <= 12) {
    return buildDate(yearNum, secondNum - 1, firstNum);
  }

  if (secondNum > 12 && firstNum <= 12) {
    return buildDate(yearNum, firstNum - 1, secondNum);
  }

  // Default to day-month-year, which matches the app's display locale.
  const dayMonthDate = buildDate(yearNum, secondNum - 1, firstNum);
  if (dayMonthDate) return dayMonthDate;

  return buildDate(yearNum, firstNum - 1, secondNum);
};

const formatDateWithShortMonth = (value: string | Date | null | undefined) => {
  if (!value) return "";

  const date =
    value instanceof Date
      ? value
      : (() => {
          const raw = String(value).trim();

          const delimitedDate = parseDelimitedDate(raw);
          if (delimitedDate) {
            return delimitedDate;
          }

          const yyyymmddMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
          if (yyyymmddMatch) {
            const [, year, month, day] = yyyymmddMatch;
            return buildDate(Number(year), Number(month) - 1, Number(day));
          }

          const dMonYyyyMatch = raw.match(/^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})(?:\s+.*)?$/);
          if (dMonYyyyMatch) {
            const [, day, monthName, year] = dMonYyyyMatch;
            const monthIndex = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].indexOf(monthName);
            if (monthIndex >= 0) {
              return buildDate(Number(year), monthIndex, Number(day));
            }
          }

          return null;
        })();

  if (!date || Number.isNaN(date.getTime())) return String(value);

  const day = String(date.getDate()).padStart(2, "0");
  const month = new Intl.DateTimeFormat("en-GB", { month: "short" }).format(date);
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatDateWithShortMonthSpaced = (value: string | Date | null | undefined) => {
  const formatted = formatDateWithShortMonth(value);
  if (!formatted) return "";
  return formatted.replace(/-/g, " ");
};

const Helpers = {
  ConsoleLog,
  ConsoleLogError,
  getDeviceName,
  getNext7Days,
  formatString,
  formatAmountInINR,
  getFormErrorMessage,
  getNext7DaysByDate,
  formatPaymentMode,
  formatDateWithShortMonth,
  formatDateWithShortMonthSpaced,
};

export default Helpers;
